import { useEffect } from 'react';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import { fetchShopItems, selectItems } from '../state';
import { ShopRouteParamsType } from '../state/types';

const useShopItems = (params: ShopRouteParamsType) => {
  const dispatch = useDispatch();
  const shopItems = useSelector((state) => selectItems(state, params));

  useEffect(() => {
    dispatch(fetchShopItems());
  }, [dispatch]);

  return shopItems;
};

export default useShopItems;
